import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations, format } from "@/lib/translations";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "fr";
    const saved = window.localStorage.getItem("bhealth_lang");
    return saved && translations[saved] ? saved : "fr";
  });

  useEffect(() => {
    try { window.localStorage.setItem("bhealth_lang", lang); } catch {}
    document.documentElement.setAttribute("lang", lang === "nl" ? "nl" : "fr");
  }, [lang]);

  const setLang = useCallback((l) => {
    if (translations[l]) setLangState(l);
  }, []);

  const t = useCallback((key, vars) => {
    const dict = translations[lang] || translations.fr;
    const s = dict[key] ?? translations.fr[key] ?? key;
    return vars ? format(s, vars) : s;
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useT() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useT must be used inside LangProvider");
  return ctx;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used inside LangProvider");
  return ctx.lang;
}
